'client-only';

import { useCallback } from 'react';

import { useRouter } from '@/hooks/useRouter';

import { useFlowContext } from './useFlowContext';
import { createFlowUrl } from '../utils/createFlowUrl';

export const useNavigation = () => {
  const context = useFlowContext();
  const router = useRouter();

  const onNext = useCallback(() => {
    if (context.nextStepRoute) {
      router.push(
        createFlowUrl({
          context,
          route: context.nextStepRoute,
          type: 'nextJsPath',
        }),
      );
    } else if (context.completionUrl) {
      // This is only relevant for legacy flows. New flows should always have a nextStepRoute.
      router.push(context.completionUrl);
    }
  }, [router, context]);

  const onBack = useCallback(() => {
    if (context.prevStepRoute) {
      // Navigating back always hard loads the page to ensure that the Next.js client-side route cache doesn't serve stale data
      window.location.assign(
        createFlowUrl({
          context,
          route: context.prevStepRoute,
          type: 'absolutePath',
        }),
      );
    }
  }, [context]);

  return {
    onNext,
    onBack,
    canNavigateBack: !!context.prevStepRoute,
  };
};
